import actions from './actions';

const {
  GET_DATA_ACTIVE,
  SET_DATA_ACTIVE,
  DELETE_DATA_ACTIVE,
  EDIT_DATA_ACTIVE,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  SET_NEW_DATA_ACTIVE,
} = actions;

const initialState = {
  data: [],
  total: 0,
  loading: false,
};

const activesReducer = (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_ACTIVE:
      return { ...state };
    case SET_DATA_ACTIVE:
      return {
        ...state,
        // Guard: respuestas de error o shapes inesperados no revientan el front.
        data: data.results || data || [],
        total: (data.results || data || []).length,
        loading: false,
      };
    case DELETE_DATA_ACTIVE:
      return {
        ...state,
        data: state.data.filter((active: any) => active.id !== data.id && active._id !== data._id),
      };
    case EDIT_DATA_ACTIVE: {
      const index = state.data.findIndex(
        (active: any) => (active.id || active._id) === (data.id || data._id)
      );
      if (index !== -1) {
        const newArray: any = [...state.data];
        newArray[index] = { ...(state.data[index] as any), ...data };
        return { ...state, data: newArray };
      }
      return { ...state, data: [...state.data, data] };
    }
    case SET_NEW_DATA_ACTIVE:
      return { ...state, data: [data, ...state.data] };
    case GET_DATA_BEGIN:
      return { ...state, loading: true };
    case GET_DATA_FINISH:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export { activesReducer };
